module.exports = ".subCategory-color {\r\n    color: black;\r\n}\r\n\r\n.caption-color {\r\n    color: #999;\r\n}\r\n\r\n.left-align {\r\n    text-align: left !important;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/design-subcategories/subcategories-grid/subcategories-grid.component.css
// module id = ./src/app/modules/dashboard/design-subcategories/subcategories-grid/subcategories-grid.component.css
// module chunks = dashboard.module